import { VitalsDto } from "../../vitals/types"
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId} = getConstants()

const { nursingApi } = api

export const getAllTriage=async(encounterId:number)=>{
    const result=await instance.get(`${nursingApi.getAllTriage}/${encounterId}?clinicId=${clinicId}`)
    return result.data.response
}

export const saveTriage=async(data:VitalsDto)=>{
    const result = await instance.post(`${nursingApi.saveTriage}`,data)
    return result.data
}